/**
 * MissingPage (U15) — landing for URLs that carry no recognizable token.
 */
import React from 'react';
import { BRAND } from '@buildledger/shared';

export function MissingPage(): JSX.Element {
  return (
    <div className="stage stage-center">
      <div className="card notice-card">
        <div className="brand-rule" />
        <h1>Nothing to show here</h1>
        <p>
          This is the {BRAND.name} document viewer. Proposals and invites open from the personal
          link in your email — check that you used the full link.
        </p>
        <p className="muted">{BRAND.tagline}</p>
      </div>
    </div>
  );
}
